import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Seuraajat',
  fields: {
    name: 'Nimi',
    subscribed: 'Tilannut',
    followed: 'Seurannut',
    phone: 'Puhelin',
    recent_order: 'Viimeisin tilaus',
    total_orders: 'Tilauksia yhteensä',
    birthday: 'Syntymäpäivä',
    google_review: 'Google-arvostelu',
    marketing_subscription_source: 'Tilattu lähteestä',
    loyalty_points: 'Kanta-asiakkuus',
  },
  empty_list: 'Ei vielä asiakkaita',
  yes: 'Kyllä',
  no: 'Ei',
  buttons: {
    import: 'Tuonti',
    export: 'Vie',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
  labels: {
    followed_since_date: 'Alkaen {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
